import { createSlice } from "@reduxjs/toolkit";
import { editChefMenuAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editChefMenuSlice = createSlice({
  name: "editChefMenu",
  initialState: data,
  reducers: {
   editChefMenuSlice(state) {
      state.isLoading = true;
    },
   editChefMenuSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editChefMenuSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editChefMenuSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const editChefMenuHandler: any = (id:any, data:any) => async (dispatch: any) => {
  try {
    dispatch(editChefMenuAction.editChefMenuSlice());
    const response: any = await editChefMenuAPI(id, data);
    
    dispatch(editChefMenuAction.editChefMenuSliceSuccess(response));
  } catch (e: any) {
    dispatch(editChefMenuAction.editChefMenuSliceFailure(e?.response?.data));
  }
};

export default editChefMenuSlice.reducer;
export const editChefMenuAction = editChefMenuSlice.actions;
